export default __webpack_public_path__ + "static/media/1.b5ba1a44.png";